import React from 'react';
import { MotionContainer } from '@/components/elements/Container';
import { OverlayingPopup } from '@/components/elements/OverlayingPopup';
import { Button } from '@/components/UI/Button';
import { useTranslationWithLocale } from '@/hooks/useTranslationWithLocale';
import { headerMenu } from '@/data/headerMenu';
import { popupMotion } from '@/animations';
import CloseIcon from '@/public/icons/cross.svg';
import { List } from './List';
import styles from './HeaderMenu.module.scss';

interface Props {
	toggleMenu: () => void;
}

export const HeaderMenu: React.FC<Props> = ({ toggleMenu }) => {
	const { t } = useTranslationWithLocale('landing-header');

	return (
		<OverlayingPopup
			onClose={toggleMenu}
			classes={{
				popup: styles['popup'],
				overlay: styles['popup__overlay'],
			}}
		>
			<MotionContainer className={styles['popup__container']} {...popupMotion}>
				<div className={styles['popup__wrapper']}>
					<div className={styles['popup__header']}>
						<Button
							as='button'
							Icon={CloseIcon}
							classes={{
								button: styles['popup__button'],
								icon: styles['popup__icon'],
								text: styles['popup__text'],
							}}
							onClick={toggleMenu}
							text={t('close')}
							iconPosition='right'
						/>
					</div>

					<div className={styles['menu']}>
						<nav className={styles['menu__list']}>
							{headerMenu.map(group => (
								<List data={group} key={group.title} toggleMenu={toggleMenu} />
							))}
						</nav>
					</div>
				</div>
			</MotionContainer>
		</OverlayingPopup>
	);
};
